export const EpimedLogoSVGCode = ({ height = `56px` }: { height?: string }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="146px"
    height={height}
    viewBox="0 0 3848 1317"
    enableBackground="new 0 0 3848 1317"
  >
    <path
      fill="#028BD2"
      opacity="1.000000"
      stroke="none"
      d="
  M704.187683,629.365845
    C697.873230,640.222595 691.553589,651.076355 685.245178,661.936584
    C666.343506,694.476990 646.222290,726.197815 621.804688,754.962891
    C592.874084,789.044617 559.742126,817.934326 518.962341,837.221802
    C489.849640,850.991272 459.268707,859.744385 427.159698,862.076416
    C407.986603,863.468994 388.605713,864.493835 369.465576,863.307129
    C334.109131,861.115112 299.791351,853.059082 267.465271,838.278381
    C167.515305,792.577454 104.954384,715.773254 85.120079,607.882507
    C66.859756,508.553558 92.754349,419.108276 159.743896,343.107239
    C204.641663,292.169769 261.516815,260.413910 328.028046,246.211517
    C330.299316,245.726532 332.642700,245.579147 335.320374,245.887787
    C334.795532,246.924774 333.942322,247.490112 333.004333,247.751755
    C253.847427,269.831940 196.314026,318.661804 157.855545,390.465118
    C131.240814,440.155762 119.992027,493.716370 119.760147,549.907593
    C119.617874,584.383911 128.663940,616.416016 144.661285,646.474304
    C172.247299,698.307251 213.767670,735.475891 267.168884,759.371643
    C287.226715,768.346985 307.991180,775.455627 330.538757,778.740601
    C335.851074,780.106995 340.590881,781.037231 346.259979,781.939453
    C352.295197,782.602234 357.387482,783.737976 362.509766,783.894592
    C374.443756,784.259277 386.392883,784.280273 398.334564,784.212280
    C430.699860,784.028015 461.512787,776.842285 490.601166,762.743347
    C527.216553,744.996094 556.318115,718.116760 581.431335,686.604187
    C603.859253,658.461182 622.607361,627.890747 639.900452,596.422913
    C648.197571,581.325012 655.807617,565.849548 664.369995,550.212769
    C672.980042,534.727112 681.001465,519.601013 688.899170,504.410614
    C694.057678,494.488739 699.036743,484.473602 704.096191,474.500244
    C720.646118,446.840515 736.721619,418.882172 753.888550,391.610870
    C768.974182,367.645966 787.043457,345.820068 806.908203,325.643677
    C851.962097,279.883209 906.003235,251.275864 969.902466,242.559296
    C994.928955,239.145401 1020.161560,238.166992 1045.358276,241.445999
    C1049.821045,242.026749 1054.215210,243.135452 1060.180908,244.271759
    C1066.832520,245.695251 1071.944336,246.847336 1077.056152,247.999420
    C1077.528687,247.987930 1078.001343,247.976471 1079.651855,248.676468
    C1093.299316,253.958801 1106.243042,257.541473 1118.162231,263.259644
    C1200.475586,302.748871 1250.933838,368.689545 1275.716064,455.389282
    C1281.474121,475.533600 1285.511230,496.137268 1286.291382,517.181580
    C1286.931396,534.446899 1289.091064,551.941406 1287.206787,568.961182
    C1281.521973,620.309509 1259.050171,664.173767 1223.589600,701.508850
    C1189.938477,736.938904 1148.942139,760.145264 1102.209106,773.329407
    C1090.166382,776.726685 1078.036011,780.917664 1065.702637,779.299194
    C1116.672974,767.352966 1158.905029,741.961243 1192.074829,702.667969
    C1235.615601,651.089233 1254.390991,591.313049 1246.228394,523.920227
    C1238.986572,464.129333 1211.672119,414.645844 1166.286621,375.462830
    C1131.181763,345.155457 1090.316650,327.117828 1044.030029,321.429321
    C1005.649292,316.712433 968.387634,320.839050 932.378235,334.680115
    C892.896606,349.855713 861.228577,375.872711 834.172974,407.830048
    C797.126709,451.587982 770.091919,501.651886 743.218262,552.527039
    C730.700928,575.590332 718.691406,598.250183 706.837280,620.990906
    C705.504272,623.548096 705.049622,626.563110 704.187683,629.365845
  z"
    />
    <path
      fill="#018CD2"
      opacity="1.000000"
      stroke="none"
      d="
  M2357.662354,599.709961
    C2335.722412,623.712097 2326.258789,651.620728 2326.303711,683.149231
    C2326.384033,739.465820 2326.326172,795.782532 2326.326172,852.099243
    C2326.326172,855.717407 2326.326172,859.335510 2326.326172,863.593384
    C2302.186768,863.593384 2278.695068,863.593384 2254.411377,863.593384
    C2254.182861,861.330811 2253.708252,858.813354 2253.706543,856.295654
    C2253.665283,793.314270 2253.049072,730.324402 2253.901123,667.354553
    C2254.440674,627.488831 2268.985352,591.972839 2293.726318,560.892212
    C2325.634766,520.808228 2367.256836,496.476532 2418.054199,490.540253
    C2475.827393,483.788818 2526.435303,501.389038 2568.863037,541.432617
    C2576.312256,548.463257 2582.958740,556.344299 2590.339111,564.220398
    C2597.217773,556.931580 2603.686768,549.488342 2610.763916,542.676880
    C2646.302002,508.472717 2688.372314,489.508118 2738.140869,489.643524
    C2815.486572,489.853973 2870.927002,526.743469 2907.595459,593.201233
    C2918.880371,613.653931 2925.187012,636.222412 2926.328613,659.875244
    C2926.840576,670.481995 2927.597168,681.093506 2927.623535,691.704407
    C2927.756348,745.021667 2927.684570,798.339417 2927.684570,851.656982
    C2927.684570,855.293640 2927.684570,858.930237 2927.684570,862.403748
    C2920.280518,864.674561 2872.057373,865.343933 2853.673828,863.422241
    C2853.673828,860.061218 2853.673828,856.529053 2853.673828,852.996826
    C2853.673584,794.014282 2853.847900,735.031006 2853.610840,676.049377
    C2853.459961,638.518677 2836.911133,608.880066 2807.842529,586.053223
    C2788.448486,570.823547 2765.975830,562.061584 2741.369385,562.520081
    C2698.570312,563.317627 2665.764648,583.206665 2643.209717,619.396729
    C2632.273682,636.943726 2627.369873,656.283691 2627.530029,677.270203
    C2627.974854,735.582947 2627.684570,793.901245 2627.684570,852.217346
    C2627.684570,855.820984 2627.684570,859.424622 2627.684570,863.620605
    C2602.998047,863.620605 2579.150391,863.620605 2554.011719,863.620605
    C2553.906006,860.431641 2553.689941,856.933960 2553.688721,853.436157
    C2553.667725,794.453613 2554.324463,735.461487 2553.462158,676.491577
    C2552.803711,631.464600 2530.921875,598.300598 2492.023193,576.163696
    C2476.719727,567.454712 2460.052246,562.598938 2442.583496,562.430908
    C2412.330811,562.139954 2386.183350,573.330200 2363.833740,593.562561
    C2361.860107,595.349182 2360.053955,597.320557 2357.662354,599.709961
  z"
    />
    <path
      fill="#1D2644"
      opacity="1.000000"
      stroke="none"
      d="
  M1420.280273,705.475098
    C1414.400635,665.560486 1420.666748,628.436096 1438.417358,593.314392
    C1450.716675,568.978516 1467.979736,548.493652 1489.518433,530.713013
    C1487.581055,528.955200 1486.069092,527.335510 1484.320801,526.033569
    C1449.474976,500.084991 1428.583374,466.001282 1423.611694,422.510223
    C1418.638672,379.008484 1427.689453,339.295410 1455.310181,304.616882
    C1475.368774,279.432678 1501.573608,263.015991 1531.534546,252.251251
    C1555.823608,243.524368 1581.067017,239.561600 1606.771240,239.380112
    C1654.097778,239.045975 1701.428345,239.277924 1748.757324,239.305969
    C1751.046387,239.307327 1753.335083,239.615799 1755.969727,239.806259
    C1755.969727,264.073395 1755.969727,288.004211 1755.969727,313.344147
    C1752.265869,313.344147 1748.746216,313.344147 1745.226562,313.344147
    C1698.230957,313.344147 1651.233398,313.084229 1604.240479,313.441284
    C1575.875122,313.656799 1550.010742,322.068787 1527.378906,339.624817
    C1485.830444,371.854706 1485.258057,429.705750 1526.224731,462.628174
    C1549.454224,481.296295 1576.471558,489.630341 1605.790649,489.959045
    C1652.447144,490.482208 1699.113647,490.098846 1745.776001,490.098846
    C1749.018799,490.098846 1752.261475,490.098816 1755.788208,490.098816
    C1755.788208,514.850708 1755.788208,538.648560 1755.788208,562.486084
    C1754.337402,562.843079 1753.401245,563.265320 1752.459839,563.277100
    C1728.149902,563.581238 1703.839478,564.041199 1679.528931,564.053833
    C1656.554077,564.065796 1633.579224,563.437134 1610.603882,563.396729
    C1592.841187,563.365540 1575.637451,566.261230 1559.322144,573.849670
    C1514.606934,594.647156 1486.921265,642.889465 1492.268433,688.532532
    C1498.837280,744.603516 1548.782349,790.552490 1604.733032,790.165527
    C1651.726318,789.840576 1698.723877,790.098816 1745.719482,790.098816
    C1748.966675,790.098816 1752.213989,790.098755 1755.891846,790.098755
    C1755.891846,814.902405 1755.891846,838.798950 1755.891846,863.496460
    C1753.611938,863.687988 1751.081543,864.084106 1748.551025,864.086060
    C1700.222168,864.122803 1651.879028,864.856262 1603.567993,863.926575
    C1542.146606,862.744446 1492.844849,836.517944 1455.468750,787.982117
    C1436.867432,763.827026 1425.716675,736.288269 1420.280273,705.475098
  z"
    />
    <path
      fill="#028CD2"
      opacity="1.000000"
      stroke="none"
      d="
  M3707.688965,318.000061
    C3707.688965,438.974091 3707.849365,558.948425 3707.605469,678.921997
    C3707.515381,723.169739 3692.390625,762.339355 3664.136963,796.161621
    C3634.678467,831.426025 3596.990967,853.540222 3551.738281,861.441528
    C3502.676270,870.007996 3457.164062,859.806763 3416.135010,831.485229
    C3373.658447,802.164490 3346.556885,761.960876 3337.191162,711.275024
    C3325.537598,648.204895 3342.364746,592.615479 3386.601074,545.992798
    C3417.812988,513.097046 3456.546143,494.853485 3501.620117,490.088562
    C3504.922363,489.739471 3508.261719,489.609711 3511.584229,489.605652
    C3541.244385,489.569458 3570.904785,489.584534 3600.564941,489.584503
    C3603.847656,489.584503 3607.130371,489.584503 3611.049561,489.584503
    C3611.049561,513.841614 3611.049561,537.326477 3611.049561,561.715759
    C3607.853271,561.895569 3604.657715,562.226135 3601.461670,562.231323
    C3575.467285,562.273743 3549.472168,562.140198 3523.478760,562.287598
    C3497.441895,562.435242 3473.609131,569.732971 3452.857910,585.694580
    C3387.141113,636.243774 3394.192383,731.647949 3463.937256,774.478271
    C3508.314209,801.729919 3562.898193,793.003174 3598.828125,757.703491
    C3622.955322,733.999634 3634.371338,705.404236 3634.349121,671.755798
    C3634.257324,532.119385 3634.311035,392.482880 3634.311035,252.846436
    C3634.311035,248.905914 3634.310791,244.965408 3634.310791,240.309052
    C3658.845459,240.309052 3682.628418,240.309052 3707.689209,240.309052
    C3707.689209,265.905212 3707.689209,291.452606 3707.688965,318.000061
  z"
    />
    <path
      fill="#1D2645"
      opacity="1.000000"
      stroke="none"
      d="
  M2000.098633,782.411499
    C2034.734985,767.782532 2057.720459,743.178772 2067.914795,707.810974
    C2079.176514,668.740417 2070.281006,633.476685 2044.272339,602.614075
    C2024.311279,578.927734 1998.492676,565.492798 1967.718384,562.543091
    C1944.849487,560.351013 1923.342285,566.206116 1903.774658,577.881409
    C1872.663696,596.444153 1853.354980,623.651184 1847.022095,659.551270
    C1845.932861,665.725525 1845.733765,672.120178 1845.730469,678.413330
    C1845.660767,812.399048 1845.677979,946.384766 1845.677979,1080.370483
    C1845.677979,1083.962646 1845.677856,1087.554810 1845.677856,1091.609741
    C1820.982300,1091.609741 1797.167358,1091.609741 1772.751099,1091.609741
    C1772.598633,1088.404785 1772.339966,1085.499146 1772.339600,1082.593506
    C1772.319580,944.274902 1772.106079,805.955750 1772.492065,667.638245
    C1772.576172,637.508606 1781.718384,609.242798 1797.073608,583.436707
    C1828.387573,530.810425 1874.719482,498.878662 1935.234375,490.537872
    C1986.538574,483.466583 2033.490967,496.687683 2074.430420,529.395447
    C2111.593018,559.085876 2135.424805,597.295715 2143.235107,643.922607
    C2153.716064,706.492249 2136.855225,761.632263 2092.481689,807.771362
    C2064.787842,836.567200 2030.852661,853.656433 1991.963257,861.158447
    C1982.232178,863.035645 1972.173706,863.874146 1962.252197,863.985107
    C1930.926147,864.335449 1899.593628,864.114075 1868.263672,864.113770
    C1866.351807,864.113770 1864.439941,864.113708 1862.096191,864.113708
    C1862.096191,839.354736 1862.096191,815.463928 1862.096191,790.729004
    C1864.429199,790.528870 1866.944214,790.129150 1869.459717,790.125488
    C1899.123169,790.081726 1928.788452,789.909485 1958.449463,790.178772
    C1972.649658,790.307678 1986.216675,787.857117 2000.098633,782.411499
  z"
    />
    <path
      fill="#028CD2"
      opacity="1.000000"
      stroke="none"
      d="
  M3053.703613,593.674194
    C3028.842529,618.546936 3016.276611,647.945557 3018.551758,682.365540
    C3020.969238,718.940002 3037.878418,748.295227 3067.711914,769.761597
    C3087.475830,783.982666 3109.585938,790.558655 3134.156006,790.371765
    C3191.483887,789.935669 3248.816895,790.232605 3306.147949,790.232605
    C3309.760498,790.232605 3313.373047,790.232605 3317.643311,790.232605
    C3317.643311,814.773621 3317.643311,838.565430 3317.643311,862.971680
    C3314.998779,863.189026 3312.431396,863.575867 3309.863037,863.582886
    C3290.863770,863.634949 3271.864502,863.544556 3252.865479,863.625244
    C3213.213623,863.793762 3173.562744,864.133545 3133.910889,864.231201
    C3082.134277,864.358765 3037.363037,846.202820 3000.855957,809.865112
    C2967.950195,777.112366 2949.097412,737.259827 2945.516113,690.305298
    C2941.712646,640.436768 2955.547119,596.130432 2986.548828,557.533447
    C3013.914062,523.463806 3049.594727,501.680969 3092.599121,492.873444
    C3143.076172,482.535461 3190.653320,490.644562 3233.854248,518.823181
    C3280.771240,549.425842 3307.355713,593.570374 3316.459961,648.654602
    C3319.530029,667.230408 3318.169189,685.703064 3317.417480,704.925964
    C3250.440186,704.925964 3183.995850,704.925964 3116.930664,704.925964
    C3116.930664,680.839661 3116.930664,657.011292 3116.930664,632.114441
    C3129.707031,630.967163 3142.582031,631.760559 3155.409668,631.618347
    C3168.740967,631.470520 3182.074951,631.585388 3195.407715,631.585388
    C3208.369141,631.585388 3221.330322,631.585388 3234.980225,631.585388
    C3234.677979,629.581238 3234.797607,628.232422 3234.274658,627.213684
    C3215.848389,591.326965 3187.120361,569.458801 3146.882324,563.640259
    C3111.281738,558.492493 3080.739990,569.639954 3053.703613,593.674194
  z"
    />
    <path
      fill="#1D2645"
      opacity="1.000000"
      stroke="none"
      d="
  M704.665161,629.899048
    C705.049622,626.563110 705.504272,623.548096 706.837280,620.990906
    C718.691406,598.250183 730.700928,575.590332 743.548950,553.134827
    C763.649048,589.379700 782.889221,625.387756 806.084656,659.077148
    C826.501038,688.730103 849.367126,716.190186 878.113831,738.275269
    C909.557556,762.432312 944.790466,777.114075 984.262756,782.293518
    C1010.207153,785.697937 1035.905029,783.180481 1061.700806,781.722290
    C1062.868164,781.656311 1063.974243,780.505920 1065.108887,779.860596
    C1078.036011,780.917664 1090.166382,776.726685 1102.209106,773.329407
    C1148.942139,760.145264 1189.938477,736.938904 1223.589600,701.508850
    C1259.050171,664.173767 1281.521973,620.309509 1287.206787,568.961182
    C1289.091064,551.941406 1286.931396,534.446899 1286.291382,517.181580
    C1285.511230,496.137268 1281.474121,475.533600 1275.716064,455.389282
    C1250.933838,368.689545 1200.475586,302.748871 1118.162231,263.259644
    C1106.243042,257.541473 1093.299316,253.958801 1080.339722,248.848450
    C1084.075806,248.527161 1088.478271,248.049332 1092.500977,249.069397
    C1142.076172,261.640381 1185.916748,284.954437 1224.075806,319.134674
    C1265.673950,356.395569 1294.900024,401.589905 1312.288086,454.541229
    C1319.766846,477.316040 1324.309204,500.646606 1326.448120,524.569153
    C1331.192505,577.633911 1323.070679,628.560913 1301.622803,677.220703
    C1273.011108,742.133118 1227.406494,791.628235 1165.234131,825.908691
    C1126.232422,847.413330 1084.358398,859.886597 1040.206055,863.075806
    C959.604248,868.897705 886.700684,848.718750 824.743835,794.881226
    C798.978516,772.492432 777.445801,746.332703 758.021362,718.436584
    C738.432739,690.304626 721.226685,660.694092 704.665161,629.899048
  z"
    />
    <path
      fill="#1C2645"
      opacity="1.000000"
      stroke="none"
      d="
  M703.481323,474.106201
    C699.036743,484.473602 694.057678,494.488739 688.899170,504.410614
    C681.001465,519.601013 672.980042,534.727112 663.841064,549.735291
    C644.745544,518.134644 627.530701,486.245789 608.688721,455.349213
    C590.966431,426.288605 569.370178,399.961670 543.902039,377.260010
    C491.996338,330.992584 431.033478,312.806427 362.274261,321.449677
    C304.901093,328.661652 256.762482,354.303467 218.651733,397.720459
    C168.597366,454.744049 150.001358,521.165649 163.997192,595.703491
    C175.632751,657.671204 208.819366,706.409302 260.112152,742.881226
    C281.443268,758.048767 305.171661,768.249268 329.964508,776.718140
    C329.965515,777.599487 329.965881,777.952026 329.966217,778.304504
    C307.991180,775.455627 287.226715,768.346985 267.168884,759.371643
    C213.767670,735.475891 172.247299,698.307251 144.661285,646.474304
    C128.663940,616.416016 119.617874,584.383911 119.760147,549.907593
    C119.992027,493.716370 131.240814,440.155762 157.855545,390.465118
    C196.314026,318.661804 253.847427,269.831940 333.004333,247.751755
    C333.942322,247.490112 334.795532,246.924774 336.214355,245.809082
    C355.896973,243.180862 375.050812,239.630371 394.210602,239.597870
    C464.117371,239.479279 526.862366,260.428711 580.320740,306.526428
    C612.859314,334.584808 639.421082,367.794434 662.147522,404.014679
    C676.441101,426.795044 689.341187,450.449738 703.481323,474.106201
  z"
    />
    <path
      fill="#1E2746"
      opacity="1.000000"
      stroke="none"
      d="
  M2213.949463,864.119812
    C2196.394043,864.119812 2179.832031,864.119812 2162.800781,864.119812
    C2162.800781,759.117920 2162.800781,655.027771 2162.800781,550.910339
    C2169.487305,548.904602 2222.913330,548.381714 2235.239014,550.301514
    C2235.239014,654.319824 2235.239014,758.408936 2235.239014,863.776978
    C2228.568115,863.889648 2221.755371,864.004761 2213.949463,864.119812
  z"
    />
    <path
      fill="#202847"
      opacity="1.000000"
      stroke="none"
      d="
  M2784.335205,1171.082886
    C2784.311279,1137.837646 2784.246582,1105.510376 2784.356689,1073.183594
    C2784.380859,1066.020996 2783.282227,1059.261353 2779.478027,1053.119629
    C2770.631592,1038.836304 2751.571045,1033.824585 2734.435547,1041.310181
    C2718.401855,1048.314453 2710.539307,1060.884033 2710.414062,1078.123047
    C2710.205811,1106.782715 2710.357178,1135.445068 2710.356934,1164.106201
    C2710.356934,1167.412354 2710.357178,1170.718628 2710.357178,1174.693848
    C2700.324463,1174.693848 2690.877930,1174.693848 2680.796387,1174.693848
    C2680.623535,1171.518311 2680.331787,1168.619995 2680.328613,1165.721558
    C2680.295166,1135.727295 2681.230225,1105.697632 2680.077393,1075.747803
    C2678.588623,1037.072876 2703.833496,1019.300598 2730.449707,1012.392456
    C2745.202148,1008.563477 2760.091309,1009.392151 2774.847656,1013.023560
    C2785.224609,1015.577209 2793.602783,1021.171265 2799.654541,1029.315430
    C2807.986328,1024.043457 2815.478516,1017.710510 2824.112305,1014.131287
    C2852.664307,1002.294800 2892.634521,1009.695374 2911.625977,1039.775513
    C2917.559082,1049.173096 2919.365479,1059.690308 2919.507324,1070.212402
    C2919.966064,1104.197632 2919.635742,1138.193604 2919.579102,1172.185425
    C2919.578125,1172.801270 2919.197021,1173.416748 2918.773438,1174.696533
    C2909.535645,1174.696533 2900.083740,1174.696533 2889.642822,1174.696533
    C2889.642822,1171.127808 2889.642822,1167.881958 2889.642822,1164.635986
    C2889.642822,1136.974609 2889.916992,1109.309570 2889.536133,1081.653442
    C2889.319336,1065.915649 2883.548096,1052.448364 2869.804688,1043.534302
    C2858.466309,1036.180298 2846.422852,1035.916626 2834.785400,1042.290283
    C2822.542236,1048.995605 2814.036133,1058.350952 2814.239990,1073.842163
    C2814.639160,1104.164429 2814.357178,1134.495483 2814.357178,1164.822998
    C2814.357178,1168.053955 2814.357178,1171.284912 2814.357178,1175.224609
    C2804.652100,1175.224609 2796.054199,1175.336426 2787.467285,1175.082275
    C2786.401367,1175.050781 2785.392578,1173.075439 2784.335205,1171.082886
  z"
    />
    <path
      fill="#202847"
      opacity="1.000000"
      stroke="none"
      d="
  M3492.412598,1016.302368
    C3514.200928,1008.107483 3535.560303,1007.183655 3556.265137,1016.197876
    C3585.738770,1029.029663 3602.280273,1052.115967 3606.357910,1084.063965
    C3608.826660,1103.406860 3605.723633,1121.762573 3595.416748,1138.369019
    C3563.004150,1190.593628 3499.683594,1185.292236 3468.969727,1155.813599
    C3428.538086,1117.008057 3433.411865,1044.914429 3492.412598,1016.302368
  M3480.479248,1126.246704
    C3481.110840,1127.016846 3481.756348,1127.776367 3482.372314,1128.558960
    C3496.976074,1147.124756 3519.370605,1154.382446 3541.913818,1147.851807
    C3560.972412,1142.330811 3578.031250,1122.046265 3580.108154,1102.289673
    C3582.945068,1075.305054 3571.876709,1056.188599 3551.465576,1044.394165
    C3529.657227,1031.792603 3501.584229,1037.631714 3484.432129,1056.773193
    C3468.457031,1074.601318 3464.782471,1103.770874 3480.479248,1126.246704
  z"
    />
    <path
      fill="#202846"
      opacity="1.000000"
      stroke="none"
      d="
  M3022.337891,1178.106567
    C2984.082031,1174.191284 2958.750732,1154.175171 2947.855713,1118.760376
    C2930.969971,1063.872070 2969.554688,1014.644348 3018.669434,1010.293152
    C3070.394775,1005.710632 3105.992432,1045.864990 3108.359619,1087.993286
    C3109.492920,1108.163208 3105.797607,1127.107666 3093.489746,1143.554932
    C3076.009277,1166.914185 3052.836426,1179.119507 3022.337891,1178.106567
  M3062.025391,1137.129517
    C3065.604004,1133.208252 3069.683105,1129.633545 3072.678711,1125.308472
    C3090.033691,1100.252808 3083.170898,1063.812012 3057.546631,1046.973999
    C3034.398682,1031.763428 3001.263428,1034.407715 2981.291504,1062.987549
    C2966.877197,1083.614258 2968.591309,1115.180786 2990.005127,1135.453369
    C3007.168213,1151.701294 3039.530273,1156.708252 3062.025391,1137.129517
  z"
    />
    <path
      fill="#202847"
      opacity="1.000000"
      stroke="none"
      d="
  M3221.838867,1041.443848
    C3205.911133,1035.295410 3191.768066,1037.572266 3178.786865,1047.147095
    C3168.803467,1054.510742 3163.595947,1064.344971 3163.651855,1076.988281
    C3163.780273,1105.969604 3163.692627,1134.951904 3163.692627,1163.933716
    C3163.692627,1167.244385 3163.692627,1170.555176 3163.692627,1174.612549
    C3153.760498,1174.612549 3144.311035,1174.612549 3134.082031,1174.612549
    C3133.934082,1171.350586 3133.664795,1168.134033 3133.661377,1164.917114
    C3133.629395,1133.936523 3134.276855,1102.938843 3133.444092,1071.980713
    C3132.762939,1046.666138 3144.110107,1029.328857 3165.701660,1018.161743
    C3192.053223,1004.532837 3231.374756,1004.979248 3256.667969,1027.202515
    C3268.277832,1037.403198 3275.302979,1050.043091 3275.524414,1065.325562
    C3276.035889,1100.629150 3275.675781,1135.945312 3275.636475,1171.256470
    C3275.635498,1172.202881 3275.261230,1173.148926 3274.929443,1174.717896
    C3265.486816,1174.717896 3256.035400,1174.717896 3245.642090,1174.717896
    C3245.642090,1171.092773 3245.642090,1167.841309 3245.642090,1164.589722
    C3245.642090,1136.607300 3245.749268,1108.624146 3245.602539,1080.642578
    C3245.511475,1063.290894 3238.246338,1049.981323 3221.838867,1041.443848
  z"
    />
    <path
      fill="#202847"
      opacity="1.000000"
      stroke="none"
      d="
  M3369.303467,1118.284424
    C3368.798828,1100.839111 3368.582764,1084.226318 3368.294189,1067.614868
    C3368.172852,1060.636230 3367.985107,1053.655762 3367.635986,1046.685791
    C3367.541748,1044.806030 3366.746338,1042.961182 3366.136963,1040.566406
    C3361.589600,1040.566406 3357.349854,1040.566406 3352.367920,1040.566406
    C3352.367920,1031.481567 3352.367920,1023.022217 3352.367920,1014.026367
    C3356.547852,1013.205811 3361.012451,1012.329346 3366.984619,1011.156860
    C3369.998779,996.939270 3367.200195,981.969788 3368.725098,966.727661
    C3378.103027,966.727661 3387.238281,966.727661 3397.692139,966.727661
    C3397.692139,976.182617 3397.691406,985.705078 3397.692139,995.227478
    C3397.693848,1013.261536 3397.694336,1013.261536 3416.106201,1013.262451
    C3423.067139,1013.262756 3430.028076,1013.262573 3437.666992,1013.262573
    C3437.666992,1022.236145 3437.666992,1030.645264 3437.666992,1040.126465
    C3427.838379,1040.126465 3417.954102,1040.078613 3408.070312,1040.140381
    C3398.735107,1040.198730 3397.824463,1040.971802 3397.734375,1050.412109
    C3397.584961,1066.054321 3397.629639,1081.699585 3397.739014,1097.342407
    C3397.766846,1101.314087 3398.132568,1105.313354 3398.711182,1109.245850
    C3401.674072,1129.384277 3413.248535,1142.071411 3432.543213,1148.009155
    C3434.413818,1148.584839 3436.200195,1149.433716 3437.989014,1150.141235
    C3437.989014,1159.373291 3437.989014,1168.280762 3437.989014,1177.152710
    C3407.726074,1179.420532 3375.734375,1152.127319 3369.303467,1118.284424
  z"
    />
    <path
      fill="#222B49"
      opacity="1.000000"
      stroke="none"
      d="
  M3632.290283,1126.000000
    C3632.290283,1088.103760 3632.290283,1051.207520 3632.290283,1013.777710
    C3642.163818,1013.777710 3651.364746,1013.777710 3661.000732,1013.777710
    C3661.529053,1018.021484 3662.040771,1022.133423 3662.739014,1027.744629
    C3677.181641,1019.809753 3689.219971,1007.985840 3707.060547,1009.943787
    C3707.060547,1019.219360 3707.060547,1028.652832 3707.060547,1038.515625
    C3705.775391,1038.803101 3704.546631,1039.268433 3703.298584,1039.328979
    C3678.699707,1040.520630 3662.085205,1057.422485 3661.785645,1082.413940
    C3661.458740,1109.702515 3661.710449,1136.998047 3661.709717,1164.290527
    C3661.709473,1167.558350 3661.709717,1170.826172 3661.709717,1174.738159
    C3651.821289,1174.738159 3642.693115,1174.738159 3632.290283,1174.738159
    C3632.290283,1158.690674 3632.290283,1142.845337 3632.290283,1126.000000
  z"
    />
    <path
      fill="#232C4A"
      opacity="1.000000"
      stroke="none"
      d="
  M3306.535156,1172.905762
    C3306.334961,1119.450684 3306.334961,1066.889160 3306.334961,1013.781250
    C3316.119629,1013.781250 3325.312988,1013.781250 3335.115723,1013.781250
    C3335.115723,1067.391479 3335.115723,1120.771606 3335.115723,1175.199463
    C3325.485840,1174.797974 3316.075684,1177.072876 3306.535156,1172.905762
  z"
    />
    <path
      fill="#222A48"
      opacity="1.000000"
      stroke="none"
      d="
  M2162.548828,530.904297
    C2162.347168,511.089752 2162.347168,492.170319 2162.347168,472.667908
    C2186.867432,472.667908 2210.667725,472.667908 2235.088379,472.667908
    C2235.088379,492.547638 2235.088379,512.335632 2235.088379,532.661682
    C2233.045898,532.911011 2231.139893,533.341003 2229.233154,533.345886
    C2209.579346,533.396362 2189.925537,533.434326 2170.272461,533.309021
    C2167.761963,533.292969 2165.257568,532.325928 2162.548828,530.904297
  z"
    />
    <path
      fill="#222947"
      opacity="1.000000"
      stroke="none"
      d="
  M3325.059570,988.008179
    C3319.697021,987.446167 3314.725830,987.737183 3310.712891,985.916077
    C3303.031738,982.430298 3299.963379,973.775391 3301.915771,964.571289
    C3303.470703,957.239807 3310.251221,951.113464 3317.925537,950.105347
    C3326.604736,948.965271 3334.795410,953.368164 3338.415527,961.119751
    C3341.890625,968.560852 3340.445801,977.798218 3334.444336,983.062500
    C3332.031006,985.179443 3328.762695,986.321533 3325.059570,988.008179
  z"
    />
    <path
      fill="#414569"
      opacity="1.000000"
      stroke="none"
      d="
  M1076.848145,247.383636
    C1071.944336,246.847336 1066.832520,245.695251 1061.054443,244.286194
    C1066.121826,243.064529 1071.736572,242.806656 1076.848145,247.383636
  z"
    />
    <path
      fill="#FEFFFF"
      opacity="1.000000"
      stroke="none"
      d="
  M329.963837,776.189392
    C305.171661,768.249268 281.443268,758.048767 260.112152,742.881226
    C208.819366,706.409302 175.632751,657.671204 163.997192,595.703491
    C150.001358,521.165649 168.597366,454.744049 218.651733,397.720459
    C256.762482,354.303467 304.901093,328.661652 362.274261,321.449677
    C431.033478,312.806427 491.996338,330.992584 543.902039,377.260010
    C569.370178,399.961670 590.966431,426.288605 608.688721,455.349213
    C627.530701,486.245789 644.745544,518.134644 663.199890,550.067627
    C655.807617,565.849548 648.197571,581.325012 639.900452,596.422913
    C622.607361,627.890747 603.859253,658.461182 581.431335,686.604187
    C556.318115,718.116760 527.216553,744.996094 490.601166,762.743347
    C461.512787,776.842285 430.699860,784.028015 398.334564,784.212280
    C386.392883,784.280273 374.443756,784.259277 362.509766,783.894592
    C357.387482,783.737976 352.295197,782.602234 346.049011,781.317871
    C339.927094,779.212708 334.945465,777.701050 329.963837,776.189392
  z"
    />
    <path
      fill="#FEFFFF"
      opacity="1.000000"
      stroke="none"
      d="
  M1065.702637,779.299194
    C1063.974243,780.505920 1062.868164,781.656311 1061.700806,781.722290
    C1035.905029,783.180481 1010.207153,785.697937 984.262756,782.293518
    C944.790466,777.114075 909.557556,762.432312 878.113831,738.275269
    C849.367126,716.190186 826.501038,688.730103 806.084656,659.077148
    C782.889221,625.387756 763.649048,589.379700 744.102661,552.755188
    C770.091919,501.651886 797.126709,451.587982 834.172974,407.830048
    C861.228577,375.872711 892.896606,349.855713 932.378235,334.680115
    C968.387634,320.839050 1005.649292,316.712433 1044.030029,321.429321
    C1090.316650,327.117828 1131.181763,345.155457 1166.286621,375.462830
    C1211.672119,414.645844 1238.986572,464.129333 1246.228394,523.920227
    C1254.390991,591.313049 1235.615601,651.089233 1192.074829,702.667969
    C1158.905029,741.961243 1116.672974,767.352966 1065.702637,779.299194
  z"
    />
    <path
      fill="#3A3B5F"
      opacity="1.000000"
      stroke="none"
      d="
  M329.964508,776.718140
    C334.945465,777.701050 339.927094,779.212708 345.119690,781.345947
    C340.590881,781.037231 335.851074,780.106995 330.538757,778.740601
    C329.965881,777.952026 329.965515,777.599487 329.964508,776.718140
  z"
    />
    <path
      fill="#FDFDFD"
      opacity="1.000000"
      stroke="none"
      d="
  M3480.137695,1125.589111
    C3464.782471,1103.770874 3468.457031,1074.601318 3484.432129,1056.773193
    C3501.584229,1037.631714 3529.657227,1031.792603 3551.465576,1044.394165
    C3571.876709,1056.188599 3582.945068,1075.305054 3580.108154,1102.289673
    C3578.031250,1122.046265 3560.972412,1142.330811 3541.913818,1147.851807
    C3519.370605,1154.382446 3496.976074,1147.124756 3482.372314,1128.558960
    C3481.756348,1127.776367 3481.110840,1127.016846 3480.137695,1125.589111
  z"
    />
    <path
      fill="#FDFDFD"
      opacity="1.000000"
      stroke="none"
      d="
  M3061.507812,1137.629272
    C3039.530273,1156.708252 3007.168213,1151.701294 2990.005127,1135.453369
    C2968.591309,1115.180786 2966.877197,1083.614258 2981.291504,1062.987549
    C3001.263428,1034.407715 3034.398682,1031.763428 3057.546631,1046.973999
    C3083.170898,1063.812012 3090.033691,1100.252808 3072.678711,1125.308472
    C3069.683105,1129.633545 3065.604004,1133.208252 3061.507812,1137.629272
  z"
    />
  </svg>
);